import React from "react";

export const TC_CHECK_CIRCLE_SVG = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7481 13.7468C23.4979 12.9857 23.4979 11.7518 22.7481 10.9907C21.9983 10.2296 20.7826 10.2296 20.0327 10.9907L12.4198 18.7178L9.7045 15.9617C8.95466 15.2006 7.73895 15.2006 6.98912 15.9617C6.23928 16.7228 6.23929 17.9567 6.98912 18.7178L11.0622 22.852C11.812 23.6131 13.0277 23.6131 13.7776 22.852C13.7805 22.849 13.7834 22.8461 13.7863 22.8431L22.7481 13.7468Z"
      fill="#2D7F52"
    />
    <circle cx="16" cy="16" r="15" stroke="#2D7F52" strokeWidth="2" />
  </svg>
);

export const TC_TIMES_CIRCLE_SVG = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="15" stroke="white" strokeWidth="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7497 10.5355C12.1383 9.92411 11.1469 9.92411 10.5355 10.5355C9.92406 11.147 9.92406 12.1383 10.5355 12.7498L13.8568 16.0711L10.5355 19.3924C9.92411 20.0038 9.92411 20.9952 10.5356 21.6066C11.147 22.218 12.1383 22.218 12.7498 21.6066L16.071 18.2853L19.3923 21.6066C20.0038 22.218 20.9951 22.218 21.6065 21.6066C22.218 20.9952 22.218 20.0038 21.6065 19.3924L18.2853 16.0711L21.6066 12.7498C22.218 12.1383 22.218 11.147 21.6066 10.5356C20.9952 9.92411 20.0038 9.92411 19.3924 10.5355L16.071 13.8569L12.7497 10.5355Z"
      fill="white"
    />
  </svg>
);

export const TC_TIMES_SVG = (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.74971 5.53579C7.13827 4.92435 6.14693 4.92436 5.5355 5.53579C4.92406 6.14723 4.92406 7.13856 5.5355 7.75L8.85684 11.0713L5.53555 14.3926C4.92411 15.0041 4.92411 15.9954 5.53555 16.6068C6.14699 17.2183 7.13832 17.2183 7.74976 16.6068L11.071 13.2856L14.3923 16.6068C15.0038 17.2183 15.9951 17.2183 16.6065 16.6068C17.218 15.9954 17.218 15.0041 16.6065 14.3926L13.2853 11.0713L16.6066 7.75C17.218 7.13857 17.218 6.14723 16.6066 5.53579C15.9952 4.92436 15.0038 4.92436 14.3924 5.53579L11.071 8.85713L7.74971 5.53579Z"
      fill="white"
    />
  </svg>
);

export const TC_CHECK_CIRCLE_FILLED_SVG = (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9087 15.8662C30.8594 14.9345 30.8594 13.424 29.9087 12.4923C28.958 11.5607 27.4167 11.5607 26.466 12.4923L16.5015 22.2577L13.5803 19.395C12.6297 18.4634 11.0883 18.4634 10.1377 19.395C9.18701 20.3267 9.187 21.8372 10.1377 22.7689L14.7279 27.2673C15.571 28.0935 16.8785 28.187 17.8268 27.5479C18.0444 27.4377 18.2487 27.2932 18.4311 27.1143L29.9087 15.8662Z"
      fill="var(--green)"
    />
  </svg>
);

export const TC_FULL_DESCRIPTION_SPEAK_TEXT = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 7.99991C12 6.43104 11.0934 5.07545 9.77783 4.42212V11.5821C11.0934 10.9244 12 9.56879 12 7.99991Z"
      fill="white"
    />
    <path d="M0 5.33313V10.6665H3.55554L8 15.1109V0.888672L3.55554 5.33313H0Z" fill="white" />
    <path
      d="M9.77783 0.204346V2.03989C12.3467 2.80435 14.2223 5.1821 14.2223 7.99989C14.2223 10.8177 12.3467 13.1954 9.77783 13.9599V15.7954C13.3378 14.9866 16 11.8088 16 7.99989C16 4.19101 13.3378 1.01322 9.77783 0.204346Z"
      fill="white"
    />
  </svg>
);

export const TC_FULL_DESCRIPTION_PAUSE_SPEAK_TEXT = (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 168.5 168.5"
    width="16"
    height="16"
  >
    <path fill="white" d="M9.25,168.5V0h51v168.5H9.25z M159.25,168.5V0h-51v168.5H159.25z" />
  </svg>
);
